import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

export const pushDataLayer = (action: string, label: string): void => {
    dataLayerPush({
        event: EVENTS.UAevent,
        category: CATEGORIES.newPayment,
        action,
        label,
    });
};
